// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0.25 0.25 13.5 13.5'
    ...attributes
  ><g data-name='Group 13494' transform='translate(1 1)'><rect
        width='7.8'
        height='7.8'
        data-name='Rectangle 5051'
        rx='1'
        style='fill:none;stroke:var(--icon-color, #000);stroke-linecap:round;stroke-linejoin:round;stroke-width:var(--icon-stroke-width, 1.5px)'
        transform='translate(4.2 4.2)'
      /><path
        d='M3.8 9.8h-.6A1.2 1.2 0 0 1 2 8.6V3.2A1.2 1.2 0 0 1 3.2 2h5.4a1.2 1.2 0 0 1 1.2 1.2v.6'
        data-name='Path 85688'
        style='fill:none;stroke:var(--icon-color, #000);stroke-linecap:round;stroke-linejoin:round;stroke-width:var(--icon-stroke-width, 1.5px)'
        transform='translate(-2 -2)'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Copy';
export default IconComponent;
